import { Component, ViewChild, OnInit } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { RBTeamMember } from '../../Models/Team';
import { SharedService } from 'src/app/core/Services/shared.service';
import { TeamService } from '../../Services/team.service';
import { NotificationService } from 'src/app/core/Services/notification.service';
import { VERBIAGE } from 'src/app/config';

@Component({
    selector: 'team-member-list',
    templateUrl: './team-member-list.component.html'
})

export class TeamMemberListComponent implements OnInit {

    Members: MatTableDataSource<RBTeamMember>;
    columns: string[] = ['fullName', 'title', 'gsl', 'options'];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sorting: MatSort;

    constructor(private _shared: SharedService, private _team: TeamService, private _notify: NotificationService) {
        // Show loader
        this._shared.loadingState = true;
        
        // Setting up page title
        this._shared.pageTitle = 'Our Team';

        // Display & subscribe to search
        this._shared.displaySearchBox.next(true);
        this._shared.searchString.subscribe(res => {
            if (this.Members) { this.Members.filter = res; }
        });
    }

    ngOnInit() {
        // Get all Members
        this._team.getAllMembers().subscribe(res => {
            this.Members = new MatTableDataSource<RBTeamMember>(res['result'])
            setTimeout(() => {
                this.Members.paginator = this.paginator;
                this.Members.sort = this.sorting;
                this._shared.loadingState = false;
            });
        });
    }

    // Delete teammember
    deleteTeamMember(teammemberID: number, name: string) {
        const _this = this;
        // Ask for confirmation
        this._notify.openDialog({
            color: 'warn', title: VERBIAGE.DELETE_TEAMMEMBER_TITLE,
            body: (VERBIAGE.DELETE_TEAMMEMBER_NAME_DISPLAY) ?
                    `${VERBIAGE.DELETE_TEAMMEMBER_BODY_HEAD} <strong>${name}</strong> ${VERBIAGE.DELETE_TEAMMEMBER_BODY_TAIL}` :
                    `${VERBIAGE.DELETE_TEAMMEMBER_BODY_HEAD} ${VERBIAGE.DELETE_TEAMMEMBER_BODY_TAIL}`,

            handlers: [{
                text: 'Confirm', type: '-raised-', color: 'warn', action() {
                    // Deleted from DB
                    _this._team.deleteMemberByID(teammemberID).subscribe(res => {
                        if (res['status'] === 'OK') {
                            // Remove from local list
                            let index = _this.Members.data.findIndex(x => x.teammemberID === teammemberID);
                            _this.Members.data.splice(index, 1);
                            _this.Members.paginator = _this.paginator;

                            _this._notify.toastMessage({
                                message: `${name} ${VERBIAGE.DELETE_TEAMMEMBER_SUCCESS}`,
                                duration: 3000, color: 'accent'
                            });
                        }
                    }, err => _this._notify.toastMessage({
                        color: 'warn', message: VERBIAGE.DELETE_TEAMMEMBER_FAIL, duration: 3000
                    }));
                }
            }, { text: 'Cancel', type: '-raised-' }]
        });
    }

    ngOnDestroy() {
        // Hide search box
        this._shared.displaySearchBox.next(false);
    }
}